import { FormControl, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

import { MatchType } from '../constants/match-type';

type MatchTypeCompProps = SelectProps<MatchType> & {
    value: MatchType;
    name: string;
    includeNot: boolean;
    size?: 'medium' | 'small';
};

export class MatchTypeComp extends React.Component<MatchTypeCompProps> {
    public render(): React.ReactNode {
        const { includeNot, ...rest } = this.props;

        return (
            <FormControl style={{ minWidth: '5em' }} size={this.props.size}>
                <Select {...rest}>
                    <MenuItem value={MatchType.LIKE}>Like</MenuItem>
                    <MenuItem value={MatchType.REGEX}>RegEx</MenuItem>
                    {includeNot
                        ? [
                              <MenuItem key={MatchType.NOT_LIKE} value={MatchType.NOT_LIKE}>
                                  NOT Like
                              </MenuItem>,
                              <MenuItem key={MatchType.NOT_REGEX} value={MatchType.NOT_REGEX}>
                                  NOT RegEx
                              </MenuItem>,
                          ]
                        : undefined}
                </Select>
            </FormControl>
        );
    }
}
